// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"blogs_scrollbar__2OEmT"};